(function() {
  if (App.angularApp == null) {
    return;
  }

  App.angularApp.directive('mfMentionToggle', function() {
    return {
      restrict: 'A',
      require: '^mfMentionContainer',
      link: (function(_this) {
        return function(scope, elem, attrs, Cont) {
          return elem.on('click', function() {
            if (!Cont.get('is_open')) {
              if ((Cont.get('text') != null) && Cont.get('text') !== '') {
                Cont.setText(Cont.get('text') + ' @');
              } else {
                Cont.setText('@');
              }
              return angular.element(Cont.input_elem).trigger('focus');
            } else {
              return Cont.setPattern(null, false);
            }
          });
        };
      })(this)
    };
  });

}).call(this);
